export default __webpack_public_path__ + "static/media/feae.08e884f7.png";